enum DomesticPartnerPlanStatus {
  CannotBeEnrolled = '0',
  OnlySameSex = '1',
  OnlyOppositeSexPartners = '2',
  CanBeEnrolled = '3',
}

export default DomesticPartnerPlanStatus;
